import EdCard from './src/index.vue'

EdCard.install = function (Vue) {
  Vue.component(EdCard.name, EdCard)
}

export default EdCard
